import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const STEPS = [
  { sel: "[data-testid=nav-today]", path: "/today", title: "Today", body: "Your first screen every session: process score, remaining risk budget and your equity curve. Process before profit." },
  { sel: "[data-testid=nav-ledger]", path: "/ledger", title: "Trade ledger", body: "Every trade, manual or imported. The sample account has 6 months of trades here — open one to see R-multiple and rule flags." },
  { sel: "[data-testid=nav-analytics]", path: "/analytics", title: "Analytics", body: "Win rate, expectancy, drawdown and advanced metrics. Free shows the essentials; Pro and Team unlock Sharpe, Calmar and the institutional set." },
  { sel: "[data-testid=nav-journal]", path: "/journal", title: "Journal", body: "Plan before, review after. Journalling daily keeps your discipline streak alive — the only thing ExperTraQ ever rewards." },
  { sel: "[data-testid=coach-open-btn]", path: null, title: "Ask your coach", body: "Ask about your own trading from any page — the same conversation continues on the full Coach page, where your weekly review also lives." },
];

export const startTour = () => { localStorage.setItem("xq_tour", "1"); window.dispatchEvent(new Event("xq-tour")); };

export default function Tour() {
  const [i, setI] = useState(-1);
  const [box, setBox] = useState(null);
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    const check = () => { if (localStorage.getItem("xq_tour") === "1") { localStorage.removeItem("xq_tour"); setI(0); } };
    check(); window.addEventListener("xq-tour", check); return () => window.removeEventListener("xq-tour", check);
  }, []);

  useEffect(() => {
    if (i < 0) return;
    const s = STEPS[i];
    if (s.path && loc.pathname !== s.path) { nav(s.path); return; }
    const t = setTimeout(() => {
      const el = document.querySelector(s.sel);
      if (!el) return setBox(null);
      el.scrollIntoView({ block: "nearest" });
      const r = el.getBoundingClientRect();
      setBox({ top: r.top, left: r.left, width: r.width, height: r.height });
    }, 350);
    return () => clearTimeout(t);
  }, [i, loc.pathname, nav]);

  if (i < 0) return null;
  const s = STEPS[i];
  const end = () => { setI(-1); setBox(null); };
  const last = i === STEPS.length - 1;
  const cardStyle = box ? (box.left > window.innerWidth / 2 ? { top: Math.max(16, box.top - 200), right: 24 } : { top: Math.min(box.top, window.innerHeight - 220), left: box.left + box.width + 18 }) : { top: 80, left: "50%", transform: "translateX(-50%)" };
  return (
    <div className="tour" data-testid="tour-overlay">
      {box && <div className="tour-spot" style={{ top: box.top - 6, left: box.left - 6, width: box.width + 12, height: box.height + 12 }} />}
      <div className="tour-card" style={cardStyle} data-testid="tour-card">
        <div className="tour-step">Step {i + 1} of {STEPS.length}</div>
        <h3 data-testid="tour-title">{s.title}</h3>
        <p>{s.body}</p>
        <div className="pill-row">
          {i > 0 && <button className="btn ghost sm" onClick={() => setI(i - 1)} data-testid="tour-back-btn">Back</button>}
          <button className="btn sm" onClick={() => (last ? end() : setI(i + 1))} data-testid="tour-next-btn">{last ? "Finish" : "Next"}</button>
          {!last && <button className="btn ghost sm" onClick={end} data-testid="tour-skip-btn">Skip tour</button>}
        </div>
      </div>
    </div>
  );
}
